import React, { Component } from 'react';
import Data from "../Data/Data"
import { CloudStatusIconColor } from '../Enums/ClodStatusEnum';
import CheckCircle from '@material-ui/icons/CheckCircle';
import Error from '@material-ui/icons/Error';
import RemoveCircle from '@material-ui/icons/RemoveCircle';
import Info from '@material-ui/icons/Info';
import "./CloudStatusListing.css";
import logo from "../Images/otc-large.png";
import StatusService from "../Services/ClousStatusService";
import { CircularProgress } from '@material-ui/core';


class CloudStatusOT extends Component {
    data;
    constructor() {
        super();
        this.state = {
            statusAvailable: false,
            renderObject: null
        }
        this.data = new Data();
        this.handleChangeValue = this.handleChangeValue.bind(this);
        this.GetStatus();
    }

    handleChangeValue(value) {
        this.setState({ renderObject: value, statusAvailable: true });
    }

    async GetStatus() {
        let service = new StatusService(this.data);
        let entry = await service.getOTStatus().then(function (entries) {
            console.log(entries);
            return (entries[0]);
        }).catch(function (error) {
            console.error(error);
        })

        if (entry !== undefined) {
            console.log(entry);
            this.handleChangeValue(entry);
        }

    }


    getIconImage(color) {
        switch (color) {
            case CloudStatusIconColor.Green:
                return <CheckCircle fontSize="large" className="icon md-green" />
            case CloudStatusIconColor.Red:
                return <Error fontSize="large" className="icon md-red"></Error>
            case CloudStatusIconColor.Orange:
                return <RemoveCircle fontSize="large" className="icon md-orange"></RemoveCircle>
            case CloudStatusIconColor.Blue:
                return <Info fontSize="large" className="icon md-blue"></Info>
            default:
                return null;
        }
    }


    render() {
        if (this.state.statusAvailable) {
            return (
                <div className="new-body">
                    <div className="lp-headerContainer">
                        <a href="https://www.abacusnext.com/">
                            <div className="cr-top-logo">
                            </div>
                        </a>
                    </div>
                    <div className="cr-body-container">
                        <div className="cr-top-container">
                            <img id="lp-AmicusOnlineLogoImg" src={logo} alt="Office Tools Cloud" />
                            <span className="cr-title">System Status</span>
                        </div>
                        <div className="cr-middle-container">
                            <div className="cr-middle-title">
                                <p>
                                    Your OfficeTools Cloud subscription guarantees 99.9% uptime. We are proud to report
                                        that we’ve averaged better than 99.99% uptime since our launch. In the unlikely
                                        event that you encounter a problem, this dashboard is intended to help explain what
                            might be happening.<br />
                                </p>
                                <p>
                                    We don’t expect you’ll ever need to visit this page again, but it is here should
                            the need ever arise.<br />
                                </p>
                            </div>
                            <div className="cr-middle-status">
                                <div className="cr-middle-status-title">
                                    <span>System status of Office Tools Cloud</span>
                                    <span className="cr-middle-status-date"></span>
                                </div>
                                <table style={{ width: "99%" }}>
                                    <tbody><tr>
                                        <td rowSpan="2" className="status-image">
                                            {(this.state.statusAvailable) ? this.getIconImage(this.state.renderObject.IconColor._) : null}

                                        </td>
                                        <td className="status-header-text">
                                            {(this.state.statusAvailable) ? (<div dangerouslySetInnerHTML={{ __html: this.state.renderObject.Header._ }} />) : null}
                                        </td>
                                    </tr>
                                        <tr>
                                            <td className="status-description-text">
                                                <div id="acsd_status-description"><br /><br /> {(this.state.statusAvailable) ? (<div dangerouslySetInnerHTML={{ __html: this.state.renderObject.DisplayText._ }} />) : null}
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody></table>
                            </div>
                        </div>
                    </div>
                    <div className="amicus-policy">
                        <table style={{ width: "100%", marginTop: "15px" }}>
                            <tbody><tr>
                                <td className="amicus-terms">
                                    <a href="#" id="lkTermsOfService" className="link-no-underline" onClick={() => window.open('https://www.officetools.com/officetools-cloud-terms/', '_blank', 'fullscreen=no')}>Terms of Service |
                            License Agreement</a>
                                </td>
                                <td className="amicus-copyright">Copyright © 2012-{new Date().getFullYear()} Abacus Data Systems, Inc. All rights reserved.
                                                </td>
                                <td className="amicus-significant">
                                    <a href="#" id="lkPrivacy" className="link-no-underline" onClick={() => window.open('https://www.abacusnext.com/privacy-policy', '_blank', 'fullscreen=no')}>Privacy Policy</a>
                                </td>
                            </tr>
                            </tbody></table>
                    </div>
                </div >

            );
        }
        else {
            return (
                <div>
                    <CircularProgress variant="indeterminate"></CircularProgress>
                    Getting status...
                </div>
            );
        }

    }
}

export default CloudStatusOT;
